<!-- 业务类型 从表 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj="{}"
      :option="{}"
      :colObj="{
        opId: '20005',
        name: '业务逻辑',
        parentId: 'FILECLASS_ID',
        parentName: '文件类型定义',
        parentPath: '/system/fileclass',
        dataClass: 2,
      }"
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablecSon";
export default {
  components: {
    Table,
  },
  data() {
    return {
    };
  },
  computed: {},
  methods: {
     addBtnClick() {
      this.dialogVisible = true;
    },
  },
  created() {},
  activated() {
    this.isTree = this.$route.query.IS_TREE == 1;
    if (this.firstEnter) {
      this.firstEnter = false;
    } else {
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
